import { createSelector } from 'reselect';

const pickState = (state: any) => state.logout;

export const getLogoutError = createSelector(
  [pickState],
  logout => logout.error,
);

export const getLogoutSuccess = createSelector(
  [pickState],
  state => state.success,
);
